<div class="container">
  <header>
      <h1>Privacy Policy</h1>
      <p>Effective Date: February 6, 2025</p>
  </header>
  <section>
      <h2>1. Introduction</h2>
      <p>Welcome to Hyperdrive. We value your privacy and are committed to protecting your personal data.</p>
  </section>
  <section>
      <h2>2. Information We Collect</h2>
      <p>We collect information such as your name, contact details, location, and payment information to enhance our services.</p>
  </section>
  <section>
      <h2>3. How We Use Your Information</h2>
      <ul>
          <li>To provide and improve our taxi services.</li>
          <li>To process payments securely.</li>
          <li>To communicate updates and offers.</li>
      </ul>
  </section>
  <section>
      <h2>4. Data Security</h2>
      <p>We implement security measures to protect your data but cannot guarantee absolute security.</p>
  </section>
  <section>
      <h2>5. Contact Us</h2>
      <p>If you have any questions, contact us at support&#64;hyperdrive.com.</p>
  </section>
</div>
